import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import CriterionServices from "./Criteria.services"
toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getCriterion = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: true,
    });
    const resp = await CriterionServices.getCriterion(filters);
    dispatch({
      type: actions.GET_CRITERION,
      payload: {
        criteria: resp.data.data,
        criteriaLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: false,
    });
  }
};

export const getCriterionById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: true,
    });
    const resp = await CriterionServices.getCriterionByID(id);
    dispatch({
      type: actions.GET_CRITERION,
      payload: {
        criteria: resp.data,
      },
    });
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: false,
    });
  }
};

export const saveCriterion =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_CRITERION,
        payload: true,
      });
      const resp = await CriterionServices.saveCriterion(data);
      const { criteria, criteriaLength } = getState().criterion;
      const _criteria = [...criteria, resp.data];
      dispatch({
        type: actions.GET_CRITERION,
        payload: {
          criteria: _criteria,
          criteriaLength: criteriaLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_CRITERION,
        payload: false,
      });
    }
  };

export const editCriterion =
  (data, id, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_CRITERION,
        payload: true,
      });
      const resp = await CriterionServices.editCriterion(id, data);
      const { criteria, criteriaLength } = getState().criterion;
      criteria[index] = resp.data;
      dispatch({
        type: actions.GET_CRITERION,
        payload: {
          criteria: criteria,
          criteriaLength: criteriaLength,
        },
      });
      dispatch({
        type: actions.FORM_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_CRITERION,
        payload: false,
      });
    }
  };

export const deleteCriterion = (id, index) => async (dispatch, getState) => {
  try {
   
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: true,
    });
    await CriterionServices.deleteCriterion(id);
    const { criteria, criteriaLength } = getState().criterion;
    criteria.splice(index, 1);
    dispatch({
      type: actions.GET_CRITERION,
      payload: {
        criteria: criteria,
        criteriaLength: criteriaLength - 1,
      },
    });
    dispatch({
      type: actions.CRITERION_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.CRITERION_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_CRITERION,
      payload: false,
    });
  }
};
